import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingSpin = ({ height, width }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height, width }}
    >
      <Spinner size="sm"></Spinner>
    </div>
  );
};

export default LoadingSpin;
